const getResultsByIndex = (allSearchResults, indexName) => {
  return (
    // this is an array of all search results and we might have multiple results for the same index
    // so we need to find the latest result for our index
    allSearchResults.slice().reverse().find((searchResult) => searchResult.indexId === indexName)?.results ?? null
  );
};
export {
  getResultsByIndex
};
//# sourceMappingURL=get-results-by-index.js.map
